import React, { useCallback, useState } from 'react';

import { Switch } from 'antd';

import { BillingReminderTermsDialog } from './BillingReminderTermsDialog';

type SendBillingReminderSettingProps = {
  isActive: boolean;
  onChange: (isActive: boolean) => void;
  disabled?: boolean;
};

const SendBillingReminderSetting = ({ isActive, onChange, disabled }: SendBillingReminderSettingProps) => {
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  const handleToggle = useCallback(
    (nextIsActive: boolean) => {
      const isDisabling = isActive && !nextIsActive;

      if (isDisabling) {
        setIsTermsOpen(true);
        return;
      }

      onChange(nextIsActive);
    },
    [isActive, onChange]
  );

  const handleClose = useCallback(() => {
    setIsTermsOpen(false);
  }, []);

  const handleConfirm = useCallback(() => {
    setIsTermsOpen(false);
    onChange(false);
  }, [onChange]);

  return (
    <>
      <div className='flex items-center gap-2'>
        <Switch checked={isActive} onChange={handleToggle} disabled={disabled} />
        <span>Enviar notificações de renovação</span>
      </div>
      <p className='mt-1 text-xs text-gray-500'>
        Será enviado e-mail para o cliente informando a renovação de sua assinatura.
      </p>

      <BillingReminderTermsDialog open={isTermsOpen} onClose={handleClose} onConfirm={handleConfirm} />
    </>
  );
};

export default SendBillingReminderSetting;
